import { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { paths } from 'config'
import { useDispatch } from 'react-redux'
import { useAuth, useUserActions, useUserRole } from 'shared/hooks'
import { LoadingStatus, ModuleRoute, UserRole } from 'shared/types'
import Route from 'shared/components/Route'
import { getCurrentAuthenticatedUser } from 'shared/store/auth/actions'

const PrivateRoute = (props: Omit<ModuleRoute, 'component'>) => {
  const { path, isConfig: isPathConfig, role } = props
  const { isAuthenticated } = useAuth()
  const { actions, nextActionPath } = useUserActions()
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const { isAllowed, loading, userType } = useUserRole()

  useEffect(() => {
    dispatch(getCurrentAuthenticatedUser())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path])

  const isRegistrationComplete =
    typeof actions?.isRegistrationComplete === 'boolean' &&
    actions?.isRegistrationComplete

  if (!isAuthenticated)
    return (
      <Redirect
        to={{ pathname: paths.login, state: { from: `${pathname}${search}` } }}
      />
    )
  if (
    (isRegistrationComplete && isPathConfig) ||
    (role && !isAllowed(role) && loading === LoadingStatus.Succeeded)
  )
    return (
      <Redirect
        to={
          userType === UserRole.Lawyer
            ? paths.lawyerLawsuits
            : userType === UserRole.Accountant
            ? paths.accountantHome
            : paths.home
        }
      />
    )
  if (!isRegistrationComplete && !isPathConfig && nextActionPath)
    return <Redirect to={nextActionPath} />
  return <Route {...props} />
}

export default PrivateRoute
